// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"254":"06af28c2","503":"e9101d4c","736":"ad9f1607"}[chunkId] + ".chunk.css";
};